import React from "react";
import "./Footer.css";
import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* LEFT: PROFILE */}
        <div className="footer-section">
          <h3 className="footer-title">Dr. Rajkamal Upadhyaya</h3>
          <p className="footer-subtext">
            Assistant Professor • Researcher • Academic Professional
          </p>
        </div>

        {/* MIDDLE: CONTACT */}
        <div className="footer-section">
          <h4 className="footer-heading">Contact</h4>

          <p className="footer-item">
            <Mail className="footer-icon" />
            <a href="mailto:rajkamalupadhyaya@gmail.com">
              rajkamalupadhyaya@gmail.com
            </a>
          </p>

          <p className="footer-item">
            <Phone className="footer-icon" />
            <a href="tel:+919759477711">+91 97594 77711</a> &nbsp; | &nbsp;
            <a href="tel:+919410685711">+91 94106 85711</a>
          </p>

          <p className="footer-item">
            <MapPin className="footer-icon" />
            D202, VTP Urban Life, MIDC Road, Talegaon,<br />
            Pune, Maharashtra – 410507
          </p>
        </div>

        {/* RIGHT: QUICK LINKS */}
        <div className="footer-section">
          <h4 className="footer-heading">Quick Links</h4>

          <ul className="footer-links">
            <li><a href="#achievements">Achievements</a></li>
            <li><a href="#research">Research</a></li>
            <li><a href="#publications">Publications</a></li>
            <li><a href="#experience">Experience</a></li>
          </ul>
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} Dr. Rajkamal Upadhyaya — All Rights Reserved
      </div>
    </footer>
  );
};

export default Footer;
